/**
 * Generated by orval v6.17.0 🍺
 * Do not edit manually.
 * Review.Api
 * OpenAPI spec version: 1.0
 */
import type { MutationFunction, QueryFunction, QueryKey, UseMutationOptions, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
    GetNotificationSettingsResponse,
    GetNotificationsResponse,
    GetSignalRConnectionInformationResponse,
    GetSubscribedReportIdsResponse,
    NotificationSettings,
    ProblemDetails,
    UpdateNotificationRequest,
    UpdateReportSubscriptionRequest,
} from '../../model';
import type { ErrorType } from '../../utils/UseCustomInstance';
import { useCustomInstance } from '../../utils/UseCustomInstance';

export const useGetNotificationsHook = () => {
    const getNotifications = useCustomInstance<GetNotificationsResponse>();

    return (signal?: AbortSignal) => {
        return getNotifications({ url: `/Notifications/GetNotifications`, method: 'get', signal });
    };
};

export const getGetNotificationsQueryKey = () => [`/Notifications/GetNotifications`] as const;

export const useGetNotificationsQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetNotificationsHook>>>,
    TError = ErrorType<ProblemDetails>
>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetNotificationsHook>>>, TError, TData>;
}): UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetNotificationsHook>>>, TError, TData> & { queryKey: QueryKey } => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetNotificationsQueryKey();

    const getNotifications = useGetNotificationsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetNotificationsHook>>>> = ({ signal }) =>
        getNotifications(signal);

    return { queryKey, queryFn, ...queryOptions };
};

export type GetNotificationsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetNotificationsHook>>>>;
export type GetNotificationsQueryError = ErrorType<ProblemDetails>;

export const useGetNotifications = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetNotificationsHook>>>,
    TError = ErrorType<ProblemDetails>
>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetNotificationsHook>>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions = useGetNotificationsQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
};

export const useGetSignalRConnectionInformationHook = () => {
    const getSignalRConnectionInformation = useCustomInstance<GetSignalRConnectionInformationResponse>();

    return (signal?: AbortSignal) => {
        return getSignalRConnectionInformation({ url: `/Notifications/GetSignalRConnectionInformation`, method: 'get', signal });
    };
};

export const getGetSignalRConnectionInformationQueryKey = () => [`/Notifications/GetSignalRConnectionInformation`] as const;

export const useGetSignalRConnectionInformationQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetSignalRConnectionInformationHook>>>,
    TError = ErrorType<ProblemDetails>
>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSignalRConnectionInformationHook>>>, TError, TData>;
}): UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSignalRConnectionInformationHook>>>, TError, TData> & {
    queryKey: QueryKey;
} => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetSignalRConnectionInformationQueryKey();

    const getSignalRConnectionInformation = useGetSignalRConnectionInformationHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetSignalRConnectionInformationHook>>>> = ({ signal }) =>
        getSignalRConnectionInformation(signal);

    return { queryKey, queryFn, ...queryOptions };
};

export type GetSignalRConnectionInformationQueryResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useGetSignalRConnectionInformationHook>>>
>;
export type GetSignalRConnectionInformationQueryError = ErrorType<ProblemDetails>;

export const useGetSignalRConnectionInformation = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetSignalRConnectionInformationHook>>>,
    TError = ErrorType<ProblemDetails>
>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSignalRConnectionInformationHook>>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions = useGetSignalRConnectionInformationQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
};

export const useUpdateNotificationHook = () => {
    const updateNotification = useCustomInstance<void>();

    return (updateNotificationRequest: UpdateNotificationRequest) => {
        return updateNotification({
            url: `/Notifications/UpdateNotification`,
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            data: updateNotificationRequest,
        });
    };
};

export const useUpdateNotificationMutationOptions = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useUpdateNotificationHook>>>,
        TError,
        { data: UpdateNotificationRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateNotificationHook>>>,
    TError,
    { data: UpdateNotificationRequest },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const updateNotification = useUpdateNotificationHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useUpdateNotificationHook>>>,
        { data: UpdateNotificationRequest }
    > = (props) => {
        const { data } = props ?? {};

        return updateNotification(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type UpdateNotificationMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUpdateNotificationHook>>>>;
export type UpdateNotificationMutationBody = UpdateNotificationRequest;
export type UpdateNotificationMutationError = ErrorType<ProblemDetails>;

export const useUpdateNotification = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useUpdateNotificationHook>>>,
        TError,
        { data: UpdateNotificationRequest },
        TContext
    >;
}) => {
    const mutationOptions = useUpdateNotificationMutationOptions(options);

    return useMutation(mutationOptions);
};
export const useGetNotificationSettingsHook = () => {
    const getNotificationSettings = useCustomInstance<GetNotificationSettingsResponse>();

    return (signal?: AbortSignal) => {
        return getNotificationSettings({ url: `/Notifications/GetNotificationSettings`, method: 'get', signal });
    };
};

export const getGetNotificationSettingsQueryKey = () => [`/Notifications/GetNotificationSettings`] as const;

export const useGetNotificationSettingsQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetNotificationSettingsHook>>>,
    TError = ErrorType<ProblemDetails>
>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetNotificationSettingsHook>>>, TError, TData>;
}): UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetNotificationSettingsHook>>>, TError, TData> & { queryKey: QueryKey } => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetNotificationSettingsQueryKey();

    const getNotificationSettings = useGetNotificationSettingsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetNotificationSettingsHook>>>> = ({ signal }) =>
        getNotificationSettings(signal);

    return { queryKey, queryFn, ...queryOptions };
};

export type GetNotificationSettingsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetNotificationSettingsHook>>>>;
export type GetNotificationSettingsQueryError = ErrorType<ProblemDetails>;

export const useGetNotificationSettings = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetNotificationSettingsHook>>>,
    TError = ErrorType<ProblemDetails>
>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetNotificationSettingsHook>>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions = useGetNotificationSettingsQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
};

export const useUpdateNotificationSettingsHook = () => {
    const updateNotificationSettings = useCustomInstance<void>();

    return (notificationSettings: NotificationSettings) => {
        return updateNotificationSettings({
            url: `/Notifications/UpdateNotificationSettings`,
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            data: notificationSettings,
        });
    };
};

export const useUpdateNotificationSettingsMutationOptions = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useUpdateNotificationSettingsHook>>>,
        TError,
        { data: NotificationSettings },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateNotificationSettingsHook>>>,
    TError,
    { data: NotificationSettings },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const updateNotificationSettings = useUpdateNotificationSettingsHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useUpdateNotificationSettingsHook>>>,
        { data: NotificationSettings }
    > = (props) => {
        const { data } = props ?? {};

        return updateNotificationSettings(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type UpdateNotificationSettingsMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useUpdateNotificationSettingsHook>>>
>;
export type UpdateNotificationSettingsMutationBody = NotificationSettings;
export type UpdateNotificationSettingsMutationError = ErrorType<ProblemDetails>;

export const useUpdateNotificationSettings = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useUpdateNotificationSettingsHook>>>,
        TError,
        { data: NotificationSettings },
        TContext
    >;
}) => {
    const mutationOptions = useUpdateNotificationSettingsMutationOptions(options);

    return useMutation(mutationOptions);
};
export const useGetSubscribedReportIdsHook = () => {
    const getSubscribedReportIds = useCustomInstance<GetSubscribedReportIdsResponse>();

    return (signal?: AbortSignal) => {
        return getSubscribedReportIds({ url: `/Notifications/GetSubscribedReportIds`, method: 'get', signal });
    };
};

export const getGetSubscribedReportIdsQueryKey = () => [`/Notifications/GetSubscribedReportIds`] as const;

export const useGetSubscribedReportIdsQueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetSubscribedReportIdsHook>>>,
    TError = ErrorType<ProblemDetails>
>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSubscribedReportIdsHook>>>, TError, TData>;
}): UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSubscribedReportIdsHook>>>, TError, TData> & { queryKey: QueryKey } => {
    const { query: queryOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetSubscribedReportIdsQueryKey();

    const getSubscribedReportIds = useGetSubscribedReportIdsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetSubscribedReportIdsHook>>>> = ({ signal }) =>
        getSubscribedReportIds(signal);

    return { queryKey, queryFn, ...queryOptions };
};

export type GetSubscribedReportIdsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetSubscribedReportIdsHook>>>>;
export type GetSubscribedReportIdsQueryError = ErrorType<ProblemDetails>;

export const useGetSubscribedReportIds = <
    TData = Awaited<ReturnType<ReturnType<typeof useGetSubscribedReportIdsHook>>>,
    TError = ErrorType<ProblemDetails>
>(options?: {
    query?: UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSubscribedReportIdsHook>>>, TError, TData>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions = useGetSubscribedReportIdsQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

    query.queryKey = queryOptions.queryKey;

    return query;
};

export const useUpdateReportSubscriptionHook = () => {
    const updateReportSubscription = useCustomInstance<void>();

    return (updateReportSubscriptionRequest: UpdateReportSubscriptionRequest) => {
        return updateReportSubscription({
            url: `/Notifications/UpdateReportSubscription`,
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            data: updateReportSubscriptionRequest,
        });
    };
};

export const useUpdateReportSubscriptionMutationOptions = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useUpdateReportSubscriptionHook>>>,
        TError,
        { data: UpdateReportSubscriptionRequest },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateReportSubscriptionHook>>>,
    TError,
    { data: UpdateReportSubscriptionRequest },
    TContext
> => {
    const { mutation: mutationOptions } = options ?? {};

    const updateReportSubscription = useUpdateReportSubscriptionHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useUpdateReportSubscriptionHook>>>,
        { data: UpdateReportSubscriptionRequest }
    > = (props) => {
        const { data } = props ?? {};

        return updateReportSubscription(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type UpdateReportSubscriptionMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUpdateReportSubscriptionHook>>>>;
export type UpdateReportSubscriptionMutationBody = UpdateReportSubscriptionRequest;
export type UpdateReportSubscriptionMutationError = ErrorType<ProblemDetails>;

export const useUpdateReportSubscription = <TError = ErrorType<ProblemDetails>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useUpdateReportSubscriptionHook>>>,
        TError,
        { data: UpdateReportSubscriptionRequest },
        TContext
    >;
}) => {
    const mutationOptions = useUpdateReportSubscriptionMutationOptions(options);

    return useMutation(mutationOptions);
};
